import { render, staticRenderFns } from "./CarteiraNacionalHabilitacao.vue?vue&type=template&id=23459cca&"
import script from "./CarteiraNacionalHabilitacao.vue?vue&type=script&lang=js&"
export * from "./CarteiraNacionalHabilitacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports